import axiosClient from "../lib/axiosInterceptor";
import { ApiSeller } from "../types/seller";

export const getSeller = async (): Promise<ApiSeller[]> => {
    const res = await axiosClient.get<ApiSeller[]>("/api/AccountAPI/?AccountTypeId=1&AccountGeneral=1&CustomerId=1&CustomerType=1&PartyAccount=1&PartyType=1&PartyTypeName=1&PartyLst=1/");
    return res.data;
  };